import React from 'react';
import { Col, Row, Skeleton } from 'antd';
import { Suspense, useEffect, useState } from 'react';
import { UsersApi } from 'api/api';
import { Cards } from 'components/cards/frame/cards-frame';
import { Main } from 'container/styled';
import SetNewPasswordPage from 'pages/authentication/SetNewPasswordPage';
import EditProfile from 'pages/profile/EditProfile';
import propTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import AuthorBox, { BoxTypes } from './overview/ProfileAuthorBox';
import OrganizationProfile from './overview/OrganizationProfile';
import { getRole } from 'utility/decode-jwt';
import { PredefinedRoles } from 'constants/constants';
import { hasPermission } from 'utility/accessibility/hasPermission';

const userApi = new UsersApi();

function Settings() {
  const { t } = useTranslation();
  const [typeOfBox, setTypeOfBox] = useState(BoxTypes.profile);
  const [id, setId] = useState();
  const roles = getRole();
  const isOrganizationRole = Array.isArray(roles)
    ? roles.includes(PredefinedRoles.ORGANIZATION)
    : roles === PredefinedRoles.ORGANIZATION;
  const handleAuthorBox = value => {
    setTypeOfBox(value);
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchUserData = async () => {
    try {
      const {
        data: { roleName, id },
      } = await userApi.apiUsersMeGet();
      setId(id);
    } catch (err) {}
  };

  const renderBoxComponent = () => {
    switch (typeOfBox) {
      case BoxTypes.profile:
        return <EditProfile />;
      case BoxTypes.setPassword:
        return <SetNewPasswordPage isOnBoardingMode={false} />;
      case BoxTypes.company:
        return <OrganizationProfile />;
      default:
        return null;
    }
  };

  const getCardTitle = () => {
    const { profile, setPassword, company } = BoxTypes;

    const titles = {
      [profile]: t('edit-profile:subtitle', 'Set Up Your Personal Information'),
      [setPassword]: t('password:subtitle', 'Change Password'),
      [company]: t('edit-company:subtitle', 'Set Up Your Company Information'),
    };

    return titles[typeOfBox];
  };

  const userProfileLabel = [
    {
      title: t('global:edit-profile', 'Edit Profile'),
      icon: 'user',
      label: 'profile',
    },
    {
      title: t('global:company-settings', 'Company Settings'),
      icon: 'command',
      label: 'company',
    },
    {
      title: t('global:change-password', 'Change Password'),
      icon: 'lock',
      label: 'setPassword',
    },
  ];

  const organizationProfileLabel = [
    {
      title: t('global:edit-company', 'Edit Company'),
      icon: 'command',
      label: 'company',
    },
  ];

  return (
    <>
      <Main>
        <Row className="mt-4">
          <Col xxl={6} lg={8} md={24} xs={24}>
            <Suspense
              fallback={
                <Cards headless>
                  <Skeleton avatar />
                </Cards>
              }
            >
              <h1 style={{ fontSize: 18, fontWeight: '600' }}>{t('settings:profile-settings', 'Profile Settings')}</h1>
              <AuthorBox onClick={handleAuthorBox} type={typeOfBox} labels={userProfileLabel} />
              {isOrganizationRole && hasPermission('profile:organization-edit') && (
                <div>
                  <h1 style={{ fontSize: 18, fontWeight: '600' }}>Company Settings</h1>

                  <AuthorBox onClick={handleAuthorBox} type={[BoxTypes.company]} labels={organizationProfileLabel} />
                </div>
              )}
            </Suspense>
          </Col>
          <Col xxl={18} lg={16} md={24} xs={24}>
            <Main>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <Cards style={{ maxWidth: '100%', width: '100%', marginTop: 30 }} title={getCardTitle()}>
                  <Row justify="center" style={{ maxWidth: '100%' }}>
                    <div
                      style={{
                        display: 'flex',
                        flex: 1,
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                      }}
                    >
                      {renderBoxComponent()}
                    </div>
                  </Row>
                </Cards>
              </div>
            </Main>
          </Col>
        </Row>
      </Main>
    </>
  );
}

Settings.propTypes = {
  match: propTypes.object,
};

export default Settings;
